import React, { PureComponent } from 'react';
import { getText } from 'src/utils/i18n';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Tab } from '@alifd/next';
import eventManager from '@alife/scc-event-manager/event-manager';
import IsInView from '@alife/bc-scroll-fix/is-in-view';
import safeLog from '@alife/bc-safe-log';
import { invoke } from '../../utils/freedom-resolve/lazy-block';
import { TAB_MAP } from './config';
import renderDetailNav from './detail-nav';
import Anchors from './anchors';

import './index.scss';

const TabPane = Tab.Item;

class DetailsFloatTab extends PureComponent {
  static propTypes = {
    productId: PropTypes.number,
    ownerLoginId: PropTypes.string,
    tabs: PropTypes.arrayOf(PropTypes.string),
    i18n: PropTypes.object,
  };

  constructor(props) {
    super(props);

    const { tabs } = props;
    const newTabs = tabs || [];
    // 这里兼容后端顺序错误问题
    if (
      newTabs[1] === 'Company Profile' &&
      newTabs[2] === 'Verified Information'
    ) {
      newTabs[1] = 'Verified Information';
      newTabs[2] = 'Company Profile';
    }

    const resultTabs = (newTabs || []).map(tab => TAB_MAP[tab] || {});
    this.state = {
      isInView: true,
      activeTab: resultTabs[0] || {},
      tabs: resultTabs,
      tabWidth: '',
      tabHeight: '',
    };
  }

  componentDidMount() {
    // eventManager.on('navConAddTab', this.addTabs);
    eventManager.on('changeDetailTab', this.handleChange);
    this.setTabSize();

    const { activeTab } = this.state;
    this.updatePanel(activeTab.id, activeTab.lazyBlockId);
    eventManager.on('productSpecification:loaded', renderDetailNav);
  }

  onInViewChange = isInView => {
    this.setState({ isInView });
  };

  onNavChange(tabId) {
    if (this.state.activeTab.id === tabId) {
      this.setTabSize();
    }
  }

  setTabSize = () => {
    this.setState({
      tabWidth: this.elTab.clientWidth,
      tabHeight: this.elTab.clientHeight,
    });
  };

  addTabs = tab => {
    const { tabs } = this.state;
    const { priority } = tab || {};
    const index = tabs.findIndex(item => item.priority > priority);

    let newTabs;
    if (index < 0) {
      newTabs = tabs.concat(tab);
    } else {
      newTabs = tabs.slice();
      newTabs.splice(index, 0, tab);
    }
    this.setState({
      tabs: newTabs,
    });
  };

  handleChange = tabId => {
    const activeTab = this.state.tabs.find(item => item.id === tabId);
    this.setState({ activeTab }, () => {
      // 更新tab-body
      this.updatePanel(tabId, activeTab.lazyBlockId);
      // 重新计算tab高度
      this.setTabSize();

      this.element.scrollIntoView(true);
      safeLog('/sc.details.tabChange', 'CLK', `tab=${tabId}`);
      eventManager.trigger('detailTabChange', tabId);
    });
  };

  updatePanel(id, lazyBlockId) {
    invoke(lazyBlockId, () => {
      const elPanelNodeList = document.querySelectorAll(
        '[data-role=detail-tab-body] > .tab-body-pane',
      );

      const elPanels = Array.prototype.slice.call(elPanelNodeList);
      elPanels.forEach(panel => {
        panel.classList.remove('show');
      });

      const elPanel = elPanels.find(panel => {
        return panel.getAttribute('data-module') === `${id}`;
      });
      elPanel.classList.add('show');
    });
  }

  renderTabContent(tabId) {
    const { i18n } = this.props;
    if (tabId === 'productDetail') {
      return (
        <div id="J-richtex-nav" className="detail-nav">
          <Anchors
            id={tabId}
            i18n={i18n}
            activeId={this.state.activeTab.id}
            onChange={this.onNavChange.bind(this, tabId)}
          />
        </div>
      );
    } else if (tabId === 'companyProfile') {
      // 无cna的访问后端有bug，还是走的老代码，这里先兼容一下
      if (window._CP_VER_ === 'VO') {
        return null;
      }
      return (
        <div id="company-nav-con" className="cp-nav">
          <Anchors
            id={tabId}
            activeId={this.state.activeTab.id}
            onChange={this.onNavChange.bind(this, tabId)}
          />
        </div>
      );
    }
    return null;
  }

  render() {
    const { tabs, isInView, activeTab } = this.state;
    let { tabWidth, tabHeight } = this.state;
    const { ownerLoginId, productId, i18n } = this.props;
    const needFixed = !isInView;
    if (!needFixed) {
      tabWidth = 'auto';
      tabHeight = 'auto';
    }

    const tabMainCls = classNames({
      'tab-main': true,
      'tab-main-fixed': !isInView,
    });
    const rsaHref = `//channel.alibaba.com/complaint/reportItem.htm?bloginId=${ownerLoginId}&productId=${productId}`;

    const i18nMap = {
      reportText: getText(
        i18n,
        'detail_tab.text_report_action',
        'Report Suspicious Activity',
      ),
    };
    return (
      <div
        className="details-tab-wrapper"
        ref={el => {
          this.element = el;
        }}
        style={{ height: tabHeight }}
        data-spm="tabs"
      >
        <IsInView checkType="top" topSpace={5} onChange={this.onInViewChange} />
        <div
          className={tabMainCls}
          style={{ width: tabWidth }}
          ref={el => {
            this.elTab = el;
          }}
        >
          <Tab
            activeKey={activeTab.id}
            onChange={this.handleChange}
            shape="wrapped"
            lazyLoad={false}
          >
            {tabs.map(item => {
              const nameText = getText(i18n, item.nameKey, item.name);
              return (
                <TabPane
                  tab={
                    <span className="tab-name" title={nameText}>
                      {nameText}
                    </span>
                  }
                  key={item.id}
                  className="details-tab-pane"
                  tabStyle={{ fontWeight: 'bold' }}
                >
                  {this.renderTabContent(item.id)}
                </TabPane>
              );
            })}
          </Tab>
          <a
            className="ls-icon rsa"
            target="_blank"
            rel="noopener noreferrer"
            href={rsaHref}
            title={i18nMap.reportText}
          >
            <span className="ico-mao mao" />
            {i18nMap.reportText}
          </a>
        </div>
      </div>
    );
  }
}

export default DetailsFloatTab;
